import { MovieFormik } from './MovieFormik/index.tsx';
import { TvFormik } from './TvFormik/index.tsx';
import { areMovieFormikValues } from './helpers/areMovieFormikValues.ts';
import { type ComponentProps } from './types.ts';

export const Component = ({ initialValues, type, ...rest }: ComponentProps) =>
  areMovieFormikValues(initialValues, type) ? (
    <MovieFormik initialValues={initialValues} {...rest} />
  ) : (
    <TvFormik initialValues={initialValues} {...rest} />
  );
